import fetch from '../utils/fetch';

export function creditSeckillActivityGetForApp(memberId = '', id = '', type = 'CREDIT') {
    return fetch.get(`/creditmall/api/creditSeckillActivity/getForApp?memberId=${memberId}&id=${id}&consumeCreditType=${type}`);
}
export function creditSeckillActivityReserve(data) {
    return fetch.post('/creditmall/api/creditSeckillActivity/reserve', data);
}

export function goodsGetRecommendGoods(data) {
    return fetch.post('/creditmall/api/goods/getRecommendGoods', data);
}
